import { ExportOptions } from '../types/types';

const createExportOptions = <TData>(options: ExportOptions<TData, keyof TData>) => options;

export { createExportOptions };
